import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate, Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import { useAuth0 } from '@auth0/auth0-react'

import Appbar from './components/Appbar'
import DrawerMenu from './components/DrawerMenu'

import LoadingScreen from 'Shared/Components/LoadingScreen'
import { NotifyToast } from 'Shared/Components/NotifyToast'
import useWindowSize from 'Shared/Hooks/useWindowSize'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'

const AdminConsole = () => {
  const { i18n } = useTranslation()
  const { user } = useAuth0()
  const { organization } = useParams()
  const { send } = useFetchData()
  const windowSize = useWindowSize()
  const navigate = useNavigate()

  const drawerWidth = { "xs": 80, "lg": 280 }
  const appbarHeight = 60
  const [collapse, setCollapse] = useState()

  const [userMetaData, setUserMetaData] = useState()
  const [orgInfo, setOrgInfo] = useState()
  const [orgProjects, setOrgProjects] = useState()

  const [loading, setLoading] = useState(false)
  const [reloading, setReloading] = useState(false)

  useEffect(() => {
    const getOrgInfo = async () => {
      const body = await send({
        method: "GET",
        url: `${apiUrl}/user/org_info`,
        returnType: "json"
      })
      
      setOrgInfo(body)
    }

    const loadProjects = async () => {
      const body = await send({
        method: "GET",
        url: `${apiUrl}/user/projects`,
        returnType: "json"
      })

      setOrgProjects(body.map((i) => ({
        "value": i["project_code"],
        "label": i[`project_name_${i18n.language.toLowerCase()}`]
      })))
    }

    const init = async () => {
      setReloading(true)

      await Promise.all([
        send({ url: `${apiUrl}/user/user_metadata`, method: "GET", returnType: "json" }).then(res =>{
          if (res) {
            setUserMetaData(res["user_metadata"])
          } 
        }),
        getOrgInfo(),
        loadProjects()
      ])

      setReloading(false)
    }

    if (organization == null) {
      navigate(`/portal/${user.org_name}`)
    }

    init()
  }, [])

  useEffect(() => {
    if (windowSize["width"] < 960) {
      setCollapse(true)
    }
    else {
      setCollapse(false)
    }
  }, [windowSize])

  const setPageLoading = (value) => {
    setLoading(value)
  }

  return (<>
    <Box sx={{ display: 'flex', flexDirection: 'column'}}>
      {organization && <>
        <Appbar mode={"admin_console"} title={orgInfo ? orgInfo["orginization_name"] : ""} appbarHeight={appbarHeight} userMetaData={userMetaData} setAppbarLoading={setPageLoading}/>

        <Box sx={{ height: windowSize["height"]-appbarHeight }}>
          <Box sx={{ display: 'flex', height: "100%" }}>
            <DrawerMenu mode={"admin_console"} collapse={collapse} setCollapse={setCollapse} windowSize={windowSize} appbarHeight={appbarHeight} drawerWidth={drawerWidth}  />

            <Box sx={{ flex: 1, height: "100%", overflow: "auto", backgroundColor: "#F2F2F2", padding: "15px" }}>
              <Outlet context={{ setPageLoading, orgProjects }}/>
            </Box>
          </Box>
        </Box>
      </>}
    </Box>

    <LoadingScreen isOpen={loading || reloading} />
    
    <NotifyToast/>
  </>)
}

export default AdminConsole
